import styled from 'styled-components';

export const Title = styled.p`
  font-family: 'FontsFreeNetSFProTextBold';
  font-size: 1.2rem;
  color: var(--main);
  text-align: center;
  margin-bottom: 20px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-end;

  > img {
    cursor: pointer;
  }
`;

export const Form = styled.form`
  ${Title} {
    margin-bottom: 10px;
  }

  div {
    width: 100%;
  }

  .password {
    margin-top: 10px;
  }

  > button {
    margin-top: 30px;
    width: 100%;
  }
`;

export const SaveButton = styled.footer`
  display: flex;
  justify-content: flex-end;
  margin-top: 33px;

  div {
    width: 100%;
    max-width: 256px;
    font: 1.2rem 'FontsFreeNetSFProTextBold', sans-serif;
    border-radius: 28px;
    text-align: center;
    padding: 10px;
    cursor: pointer;
  }
`;

export const AllMonthsSelector = styled.div`
  display: flex;
  align-items: center;

  strong {
    font: 1.2rem 'FontsFreeNetSFProTextBold', sans-serif;
  }

  span {
    width: 1.5rem;
    height: 1.5rem;
    background: transparent;
    margin-right: 0.5rem;
    border: 0;
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
    }
  }
`;
